// src/pages/MetaList.js
import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Paper, Table, TableBody, TableCell,
  TableHead, TableRow, Button, Alert, Box
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const MetaList = () => {
  const { idPoa } = useParams();
  const navigate = useNavigate();
  const [metas, setMetas] = useState([]);
  const [error, setError] = useState('');
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchMetas = async () => {
      try {
        const res = await api.get(`/metas/?id_poa_proyecto=${idPoa}`);
        setMetas(res.data);
      } catch (err) {
        setError('Error al cargar las metas');
        console.error(err);
      }
    };
    fetchMetas();
  }, [idPoa]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Metas y Volúmenes de Trabajo (POA #{idPoa})</Typography>
        <Button
          variant="contained"
          onClick={() => navigate(`/poa/${idPoa}/metas/nuevo`)}
        >
          Agregar Meta
        </Button>
      </Box>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Volumen de Trabajo</TableCell>
              <TableCell>Unidad</TableCell>
              <TableCell>T1</TableCell>
              <TableCell>T2</TableCell>
              <TableCell>T3</TableCell>
              <TableCell>T4</TableCell>
              <TableCell>Año</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {metas.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">No hay metas registradas</TableCell>
              </TableRow>
            ) : (
              metas.map((meta) => (
                <TableRow
                  key={meta.id_poados}
                  hover
                  onClick={() => navigate(`/poa/${idPoa}/metas/${meta.id_poados}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <TableCell>{meta.volumen_trabajo || '—'}</TableCell>
                  <TableCell>{meta.unidad_medida || '—'}</TableCell>
                  <TableCell>{meta.trimestre1}</TableCell>
                  <TableCell>{meta.trimestre2}</TableCell>
                  <TableCell>{meta.trimestre3}</TableCell>
                  <TableCell>{meta.trimestre4}</TableCell>
                  <TableCell>{meta.anno}</TableCell>
                  <TableCell>
                    <Button
                    size="small"
                    variant="outlined"
                    onClick={(e) => { e.stopPropagation(); window.open(`${API_BASE_URL}/api/reportes/metas/${idPoa}/`, '_blank')}}
                    
                  >
                    PDF Metas
                  </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default MetaList;